import { useEffect, useState } from 'react'

import { LocalFile, PictureFieldModel, RemoteFile } from '@types'

import { UploadPicture } from '@components/UploadPicture'

import { useFilePreviews } from '@hooks/file/file-preview.hook'

type SubmitterFieldPictureProps = {
  field: PictureFieldModel
  disabled?: boolean
  onLocalFilesChange?: (files: LocalFile[]) => void
  onChange: (updates: Partial<PictureFieldModel & { localFiles: LocalFile[] }>) => void
}

export const SubmitterFieldPicture: React.FC<SubmitterFieldPictureProps> = ({
  field,
  disabled = false,
  onLocalFilesChange,
  onChange,
}: SubmitterFieldPictureProps) => {
  const [files, setFiles] = useState<(RemoteFile | LocalFile)[]>([])

  const { loadFilePreviews } = useFilePreviews({
    files: field.files as RemoteFile[],
    onFilesLoaded: (files) => (files ? setFiles(files as RemoteFile[]) : undefined),
  })

  useEffect(() => {
    loadFilePreviews()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleFilesChange = (newFiles: (LocalFile | RemoteFile)[]) => {
    const local = newFiles.filter((file): file is LocalFile => Boolean((file as LocalFile).data))
    const remote = newFiles.filter((file): file is RemoteFile => !Boolean((file as LocalFile).data))
    const undeletedRemoteFiles = remote.filter((file) => !file.deleted)

    onChange({
      fileIds: undeletedRemoteFiles.map(({ id }) => id),
    })
    onLocalFilesChange?.(local)

    setFiles(newFiles)
  }

  return (
    <UploadPicture
      multiple
      label={field.label}
      disabled={disabled}
      required={field.required}
      files={files}
      setFiles={handleFilesChange}
    />
  )
}
